import React from 'react';
import PropTypes from 'prop-types';

import {
    IconArrowRightOutline, Text,
} from '@zillow/constellation';

import { StyledFlex } from './StyledComponents';
import { StyledAnchor, StyledFadeInButton } from '../../StyledComponents';

const propTypes = {
    onSearchByOtherContactMethodsClick: PropTypes.func.isRequired,
    onViewPropertiesClick: PropTypes.func.isRequired,
};

const Transferred = ({ onSearchByOtherContactMethodsClick, onViewPropertiesClick }) => (
    <>
        <StyledFlex display="flex" flexDirection="column" alignSelf="center" marginY={6}>
            <Text>
                Next, you can view your properties in Zillow Rental Manager.
                {' '}
                You’ll be able to edit and publish the listing for each property individually.
            </Text>
            <br />
            <Text>
                To transfer more listings,
                {' '}
                <StyledAnchor onClick={onSearchByOtherContactMethodsClick}>
                    search by other contact methods.
                </StyledAnchor>
            </Text>
        </StyledFlex>
        <StyledFadeInButton
            buttonType="primary"
            onClick={onViewPropertiesClick}
        >
            View properties
            &nbsp;
            <IconArrowRightOutline />
        </StyledFadeInButton>
    </>
);

Transferred.propTypes = propTypes;

export default Transferred;
